import { useEffect, useState } from "react";
import Sider from "../../comps/sider/main";
import './main.css';
import { InstagramOutlined, FacebookFilled, CheckCircleOutlined, CommentOutlined, ExclamationCircleFilled, EyeInvisibleOutlined, DeleteOutlined, LoadingOutlined, CloseCircleOutlined, SendOutlined, ClockCircleOutlined, WarningOutlined, MoneyCollectTwoTone, GlobalOutlined, ExclamationCircleOutlined, ShopFilled, ShopOutlined, MailOutlined, BranchesOutlined, LinkOutlined, DollarCircleOutlined, VideoCameraOutlined, ApartmentOutlined } from '@ant-design/icons';
import { Popover, Switch, Breadcrumb, Drawer, Button, Space, Modal, Tabs, message, Spin, Statistic, Row, Col, Table, Tag, Tooltip, Alert, Card, Empty, Flex, Result, Steps } from 'antd';
import CountUp from 'react-countup';
import { AutoReply, AutoHide, AutoDelete } from "../../comps/automate/main";
import { useParams } from 'react-router';
import callAPI from "../../comps/fetch/main";
import { LinuxOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { BsCursor } from "react-icons/bs";

import generateInsights from "../../funcs/genrateInsights";
import { ShopifyAutomate } from "../../comps/automateShopify/main";

import { Timeline } from "antd";
import dayjs from "dayjs";
import AccessOrNot from "../../funcs/accessOrNot";
import CrownReturn from "../../comps/crownPremium/main";



function StatusTimeline({ timeline = [] }) {
    return (
        <Timeline mode="left" style={{ marginTop: 16 }}>
            {timeline.map((entry, index) => {
                const currentTime = dayjs.utc(entry.timestamp).local()
                const prevTime = index > 0 ? dayjs(timeline[index - 1].timestamp) : null;
                const diffMinutes = prevTime ? currentTime.diff(prevTime, "minute") : null;

                return (
                    <Timeline.Item key={index}>
                        <div style={{ fontWeight: 600 }}>{entry.status}</div>
                        <div style={{ fontSize: 12, color: "#888" }}>
                            {currentTime.format("YYYY-MM-DD hh:mm A")}
                        </div>
                        {/* {diffMinutes !== null && (
              <div style={{ fontSize: 12, color: "#aaa" }}>
                ⏱ +{diffMinutes} min
              </div>
            )} */}
                    </Timeline.Item>
                );
            })}
        </Timeline>
    );
}



const PostPreview = ({ igDetail, fbDetail, onLinkFacebook }) => {
    return (
        <div
            style={{
                // maxWidth: 700,
                margin: "0",
                padding: "0px 16px",
                background: "#fff",
                borderRadius: 16,
                marginTop: "20px",
                // boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                display: "flex",
                alignItems: "center",
                gap: "10px"
            }}
        >
            <p style={{ opacity: ".5", margin: 0, marginRight: "auto" }}>
                Changes will be updated on both Instagram and Facebook if Linked.
            </p>

            <div style={{ display: "flex", gap: "10px" }}>
                {/* Instagram Section */}
                {igDetail?.media_url && (
                    <Popover
                        content={
                            <img
                                src={igDetail?.thumbnail_url || igDetail?.media_url}
                                alt="Instagram"
                                style={{
                                    width: "auto",
                                    maxHeight: 200,
                                    borderRadius: 8,
                                    objectFit: "cover",
                                }}
                            />
                        }
                        title="Instagram Post"
                        trigger="hover"
                    >
                        <div
                            style={{
                                cursor: "pointer",
                                padding: "8px",
                                borderRadius: "50%",
                                background: "linear-gradient(145deg, rgba(255,245,250,0.6), rgba(250,240,255,0.6))",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                border: "1px solid #f0f0f0"
                            }}
                        >
                            <InstagramOutlined style={{ fontSize: "24px", color: "#E1306C" }} />
                        </div>
                    </Popover>
                )}

                {/* Facebook Section */}
                <Popover
                    content={
                        fbDetail?.full_picture ? (
                            <img
                                src={fbDetail.full_picture}
                                alt="Facebook"
                                style={{
                                    width: "auto",
                                    maxHeight: 200,
                                    borderRadius: 8,
                                    objectFit: "cover",
                                }}
                            />
                        ) : (
                            <div style={{ textAlign: "center", padding: "10px" }}>
                                <Empty
                                    description={<span style={{ fontSize: 12 }}>No Facebook post</span>}
                                    imageStyle={{ height: 40 }}
                                />
                                <Button
                                    type="primary"
                                    size="small"
                                    style={{ marginTop: 8, borderRadius: "4px" }}
                                    onClick={AccessOrNot("fb_automation") ? () => onLinkFacebook() : () => { }}
                                >
                                    Link Facebook Post <CrownReturn premiumUser={AccessOrNot("fb_automation")} />
                                </Button>
                            </div>
                        )
                    }
                    title="Facebook Post"
                    trigger="hover"
                >
                    <div
                        style={{
                            cursor: "pointer",
                            padding: "8px",
                            borderRadius: "50%",
                            background: "linear-gradient(145deg, rgba(240,250,255,0.6), rgba(230,240,255,0.6))",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "1px solid #f0f0f0"
                        }}
                    >
                        <FacebookFilled style={{ fontSize: "24px", color: "#1877F2" }} />
                    </div>
                </Popover>
            </div>
        </div>
    );
};

const formatter = (value) => <CountUp end={value} separator="," />;
const { confirm } = Modal;

function Automations() {
    const [messageApi, contextHolder] = message.useMessage();

    const [showDrawer, setShowDrawer] = useState(false)
    const [DrawerType, setDrawerType] = useState("")
    const [toogle, setToogle] = useState(true)

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState()
    const [initalState, setInitalState] = useState()
    const params = useParams()

    const [callPostAPi, setCallPostApi] = useState(false)
    const [posting, setPosting] = useState(false)
    const [dataPostedState, setDataPostedState] = useState()
    const [disableSection, setDisableSection] = useState()
    const [dashboardAPIData, setDashboardAPIData] = useState()

    const [postComments, setPostComments] = useState()

    const [postCommentsList, setPostCommentsList] = useState([])
    const [commentsLoading, setCommentsLoading] = useState(false)

    const [commentPagination, setCommentPagination] = useState()

    const [commentPaginationPageChange, setCommentPaginationPageChange] = useState(0)

    const [showPlan, setShowPlan] = useState(false)

    const [showAccountWaring, setShowAccountWaring] = useState(false)

    const [igDetail, setIGDetail] = useState({})
    const [fbDetail, setFBDetail] = useState({})
    const [selectedFBDetail, setSelectedFBDetail] = useState()





    const search = window.location.search;
    const urlParams = new URLSearchParams(search);
    const post_type = urlParams.get('post_type') || "posts";
    const platform_type = urlParams.get('platform_type') || "insta";
    const scheduled_post = urlParams.get('scheduled_post');



    // console.log("post_type-=-=-POST TYPE=-=-", post_type)

    const flow_editor = urlParams.get('flow_editor') || false;

    const [shopifyLinked, setShopifyLinked] = useState(false)

    const [showPublishModal, setShowPublishModal] = useState(true);
    const [publishStep, setPublishStep] = useState(0);


    useEffect(() => {
        if (!callPostAPi || callPostAPi == undefined || callPostAPi == false) {
            return
        }
        // messageApi.open({
        //     type: 'loading',
        //     content: 'Please wait updating',
        //     duration: 0,
        // });
        setPublishStep(0)
        setShowPublishModal(true)
        let payload = { ...data, fb_post_id: fbDetail?.id }



        payload["auto_reply"]["enable"] = disableSection ? false : true
        if (shopifyLinked == true) {
            payload["shopify_linked"] = true
        }
        else {
            payload["shopify_linked"] = false
        }

        const isGlobal = new URLSearchParams(window.location.search).get("is_global") === "true";
        if (isGlobal) {
            payload["global_automation"] = true;
        }

        // Add post_type for stories
        if (post_type === "stories") {
            payload["post_type"] = "story";
        }

        // Add fb_page and is_fb parameters for Facebook posts
        if (platform_type === "fb") {
            payload["fb_page"] = true;
            payload["is_fb"] = true;
        }

        let apiURL = post_type == "next-post" ? `next-post` : `automate-post`
        localStorage.setItem("previous_config", JSON.stringify(payload))
        console.log("Shopify linked0=-=-=--", payload)
        setPublishStep(1)


        if (igDetail?.children) {
            callAPI({ url: "/coursal-link-post", method: "POST", body: { posts: igDetail?.children?.data, post_id: params.id }, loadingState: () => { }, dataState: () => { } })

        }



        if (fbDetail?.id) {
            let fb_payload = { ...data, post_id: fbDetail?.id }
            if (post_type === "stories") {
                fb_payload["post_type"] = "story";
            }
            if (platform_type === "fb") {
                fb_payload["fb_page"] = true;
                fb_payload["is_fb"] = true;
            }
            callAPI({ url: apiURL, method: "POST", body: fb_payload, loadingState: () => { }, dataState: () => { } })
        }
        callAPI({ url: apiURL, method: "POST", body: payload, loadingState: setLoading, dataState: setDataPostedState })


        setCallPostApi(false)


    }, [callPostAPi])

    useEffect(() => {
        if (dataPostedState == undefined) {
            return
        }

        messageApi.destroy()
        if (dataPostedState.code != 200) {
            message.error("Something went wrong please try again later.")
            // Error
        }
        else {
            // Success and close the drwaer
            setShowDrawer(false)
            setDrawerType('')
            setPublishStep(2)

            if (disableSection) {
                setPublishStep(3)

                message.success("Automation Updated")
                message.loading("Refreshing Page")
                // setTimeout(() => {
                //     window.location.reload();
                //   }, 2000);
            }
            else {
                message.success("Automation is live")
                message.loading("Refreshing Page")
                // setTimeout(() => {
                //     window.location.reload();
                //   }, 2000);
            }
            setDisableSection(false)
        }

    }, [dataPostedState])



    function ComingSoon() {
        return (<div className="cs" style={{ width: '100%', height: '100%', margin: '0 auto', display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', justifyItems: 'center', justifyContent: 'center' }}>
            <LinuxOutlined style={{ fontSize: '40px' }} />
            <p style={{ fontSize: '20px' }}>coming soon</p></div>)
    }

    let drawerTypeObj = {
        reply: {
            title: post_type == "stories" ? "Auto Reply to Story" : "Auto Reply to Comments",
            comp: <AutoReply state={{ ...data }} setData={setData} isStory={post_type == "stories"} isNextPostReply={post_type == "next-post"} setShowplan={setShowPlan} showPlan={showPlan} igData={igDetail} isGlobal={params.id.startsWith("global-") || new URLSearchParams(window.location.search).get("is_global") === "true"} />
        },
        hide: {
            title: "Auto Hide Comments",
            comp: <ComingSoon />
            // comp: <AutoHide state= {{...data}} setData = {setData} />
        },
        delete: {
            title: "Auto Delete Comments",
            comp: <ComingSoon />
            // comp: <AutoDelete state= {{...data}} setData = {setData} />
        },
        shopify: {
            title: "Shopify Automation",
            // comp:  <div>
            //     <p>1. Select Product</p>
            //     <p>2. Select Trigger word</p>
            //     <p>3. Build the flow Automatically use varients follow ups, collect name, phone number / email , out of stock, after out of stock or after purchase send similar products</p>
            //     <p>3.5 sometimes users dont want to have flow, just send the link of product open to shopify</p>
            //     <p>4. Option to Edit the flow if requried</p>
            //     <p>5. Publish</p>
            //     </div>
            comp: <ShopifyAutomate state={{ ...data }} setData={setData} isStory={post_type == "stories"} isNextPostReply={post_type == "next-post"} setShowplan={setShowPlan} showPlan={showPlan} HandleSPPublish={HandleSPPublish} igData={igDetail} />
        }
    }

    useEffect(() => {

        if (DrawerType == "reply") {

        }
        if (DrawerType == "hide") {

        }
        if (DrawerType == "delete") {

        }

    }, [DrawerType])

    useEffect(() => {

        if (dashboardAPIData == undefined) {
            return
        }
        // console.log("==========", dashboardAPIData)
        if (dashboardAPIData?.data != undefined) {
            setDashboardAPIData({ ...dashboardAPIData?.data })
        }
        // console.log("===========dahboard api data" , dashboardAPIData)
    }, [dashboardAPIData])


    useEffect(() => {

        if (postComments == undefined) {
            return
        }
        if (postComments?.data != undefined) {
            setCommentPagination(postComments?.data?.pagination?.comment_id)
            setPostCommentsList([...postCommentsList, ...postComments?.data?.items])

        }
    }, [postComments])

    useEffect(() => {
        if (commentPaginationPageChange == 0) {
            return
        }
        let commentsURL = `ig-post-comments?post_id=${params.id}&last_comment_id=${commentPagination}&only_error=true`
        callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

    }, [commentPaginationPageChange])


    useEffect(() => {
        if (data == undefined) {
            return
        }

        if (data.data != undefined) {
            let tempData = data.data
            tempData.auto_reply.buttons = tempData.auto_reply.buttons || [{ "title": "click to edit", "url": "", "type": "web_url" }]
            setIGDetail(data?.ig_post_data)
            setFBDetail(data?.fb_post_data)

            setData({ ...data.data })

            setInitalState({ ...data.data })
        }


    }, [data])
    // 
    // console.log("post_type-=-=-=-=-", urlParams.get('post_type') , loading, data)
    useEffect(() => {

        // console.log("post_type-=-=-=-=-", urlParams.get('post_type') , loading, data)
        if (loading == true && data != undefined) {
            return
        }
        let tem_post_type = urlParams.get('post_type') || "posts";
        let apiURL = tem_post_type == "next-post" ? `next-post?post_id=${params.id}` : `automate-post?post_id=${params.id}`
        callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })

        const isGlobal = urlParams.get("is_global") === "true";

        if (isGlobal) {
            // If it's a global automation (even with a unique ID), we might want to fetch existing global config 
            // OR just start fresh/fetch based on ID if it exists. 
            // For now, let's assume if it's a new unique ID, it fetches nothing (empty) or whatever the backend returns for that ID.
            // But we MUST skip the dashboard/comments calls which are for specific posts.
            setDrawerType('')
            return;
        }

        if (params.id.startsWith("global-")) {
            let apiURL = `automate-post?post_id=${params.id}`
            callAPI({ url: apiURL, method: "GET", loadingState: setLoading, dataState: setData })
            setDrawerType('')
            return;
        }

        if (tem_post_type != "next-post") {
            let apiURLDashboard = `post-dashboard?post_id=${params.id}`
            callAPI({ url: apiURLDashboard, method: "GET", loadingState: setLoading, dataState: setDashboardAPIData })

            let commentsURL = `ig-post-comments?post_id=${params.id}`
            callAPI({ url: commentsURL, method: "GET", loadingState: setCommentsLoading, dataState: setPostComments })

        }

        setDrawerType('')
    }, [])

    const showConfirm = (action_name) => {
        confirm({
            title: `Are you sure want to disable ${action_name}?`,
            icon: <ExclamationCircleFilled />,
            content: 'You can enable at anytime with current configuration.',
            okText: "Disable",
            cancelText: 'Cancel',
            onOk() {

                setDisableSection(true)
                setCallPostApi(true)
            },
            onCancel() {

            },
        });
    };


    const [fbPosts, setFBPosts] = useState({})
    const [loadFBPosts, setLoadFBPosts] = useState(0)
    const [showFbLinkModal, setShowFbLinkModal] = useState(false)


    useEffect(() => {
        if (loadFBPosts == 0) return;

        function addQueryParam(url, key, value) {
            return url + (url.includes("?") ? "&" : "?") + `${key}=${value}`;
        }

        let apiURL = "ig-posts"
        apiURL = addQueryParam(apiURL, "fb_page", true);
        if (fbPosts?.posts_lists?.paging?.cursors?.after) {
            apiURL = addQueryParam(apiURL, "after", fbPosts.posts_lists.paging.cursors.after);
        }
        callAPI({
            url: apiURL,

            method: "GET",

            loadingState: setLoading,

            dataState: (data_) => {

                const incoming = data_?.posts_lists?.data || [];
                const existing = fbPosts?.posts_lists?.data || [];
                let combined = [...incoming];
                combined = [...existing, ...incoming];
                const sorted = combined.sort((a, b) => {
                    const timeA = new Date(a.timestamp).getTime();
                    const timeB = new Date(b.timestamp).getTime();
                    return timeB - timeA;
                });
                const mergedData = {
                    ...data_,
                    posts_lists: {
                        ...data_.posts_lists,
                        data: sorted
                    }
                };
                setFBPosts(mergedData);
            }
        });

    }, [loadFBPosts]);



    function HandlePublish() {

        setShopifyLinked(false)


        let error = 0

        if (data["auto_reply"]["collect_money"] == true) {

            if (data["auto_reply"]["payment_details"] == undefined) {
                message.error("Product Details Missing")
                error += 1
            }

            if (data["auto_reply"]["payment_details"]["product_title"] == undefined || data["auto_reply"]["payment_details"]["product_title"].length < 1) {
                message.error("Product Title Missing")
                error += 1
            }
            if (data["auto_reply"]["payment_details"]["product_description"] == undefined || data["auto_reply"]["payment_details"]["product_description"].length < 1) {
                message.error("Product Title Missing")
                error += 1
            }
            if (data["auto_reply"]["payment_details"]["r_price"] == undefined || data["auto_reply"]["payment_details"]["r_price"] < 1) {
                message.error("Product Price should be more than or equal to 1")
                error += 1
            }
        }


        if (data["auto_reply"]["automate_all"] != "true" && data["auto_reply"]["triger_words"].length < 1) {

            message.error("Missing Trigger words")
            error += 1
        }


        if (data["auto_reply"]["enable_dm_reply"] != false && data["auto_reply"]["dm_reply_type"] != "sequence" && data["auto_reply"]["automate_all"] != "true") {

            if ((data["auto_reply"]["dm_template_type"] != "button" && data["auto_reply"]["dm_template_type"] != "products") && (data["auto_reply"]["dms"] != undefined && data["auto_reply"]["dms"][0].length < 1)) {
                message.error("Missing DM text")
                error += 1
            }

        }

        if (data["auto_reply"]["enable_comment_reply"] != false && data["auto_reply"]["reply_comments"].length < 1) {

            if (post_type != "stories") {
                message.error("Missing Reply comments words")
                error += 1
            }
        }


        if (error < 1) {

            // console.log("data", data)

            if (data["auto_reply"]?.["welcome_message"]?.["enabled"] != true && data?.auto_reply?.followers_only != true) {
                setShowAccountWaring(true)
                return
            }
            setCallPostApi(true)

        }
    }

    function HandleSPPublish() {

        console.log("-=-=-=-=-=data", data)
        setShopifyLinked(true)
        // return
        let error = 0
        if (data["auto_reply"]["automate_all"] != "true" && data["auto_reply"]["triger_words"].length < 1) {

            message.error("Missing Trigger words")
            error += 1
        }
        if (data["auto_reply"]["reply_comments"].length < 1) {

            if (post_type != "stories") {
                message.error("Missing Reply comments words")
                error += 1
            }
        }

        if (error < 1) {
            if (data["auto_reply"]?.["welcome_message"]?.["enabled"] != true && data?.auto_reply?.followers_only != true) {
                // setShowAccountWaring(true)
                // return
            }
            setCallPostApi(true)

        }
    }

    useEffect(() => {



    }, [showPlan])

    function AutomationSetup() {

        if (commentsLoading || data == undefined || data.data != undefined) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }
        return (<>

            {
                post_type == "next-post" && <Alert style={{ maxWidth: "600px" }} closable showIcon type="info" message="FB and IG will be automated." description="This coufiguration will be automatically applied to your next IG and FB Page post." />
            }

            {(post_type != "next-post" && post_type != "stories" && !scheduled_post && !params.id.startsWith("global-") && new URLSearchParams(window.location.search).get("is_global") !== "true") &&
                <PostPreview
                    igDetail={igDetail}
                    fbDetail={fbDetail}
                    onLinkFacebook={() => { setShowFbLinkModal(true); setLoadFBPosts(loadFBPosts + 1) }}
                />}

            {(params.id.startsWith("global-") || new URLSearchParams(window.location.search).get("is_global") === "true") &&
                <Alert
                    message={`Global ${post_type === 'posts' ? 'Post' : 'Story'} Automation`}
                    description={`This configuration will be applied to all your ${post_type === 'posts' ? 'posts' : 'stories'}.`}
                    type="info"
                    showIcon
                    style={{ maxWidth: 700, marginTop: 20, marginBottom: 20 }}
                />
            }

            <h1> {post_type == "stories" ? "Story Automation" : post_type == "next-post" ? "Configure your Next Post automation" : "Post Automations"}</h1>


            <div className="automated-flex" style={{ paddingBottom: "20px" }}>
                <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable && !data.shopify_linked} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <LinkOutlined className="icon reply" />
                    <div>
                        <h4>Send Link or Images</h4>
                        {post_type == "stories" ?
                            <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                            :
                            <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                        }
                    </div>
                </div>

                {/* <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <MailOutlined className="icon mail" />
                    <h4>Collect Email / Whatsapp</h4>
                    {post_type == "stories" ?
                        <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                        :
                        <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                    }
                </div> */}

                <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {

                        if (!localStorage.getItem("shopify_store")) {
                            window.location.href = "/shopify";

                            // showConnectShopfyModel
                            return
                        }

                        setShowDrawer(true);
                        setDrawerType('shopify');
                    }
                }} >
                    <Switch value={data.auto_reply.enable && data.shopify_linked} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            if (!localStorage.getItem("shopify_store")) {
                                // showConnectShopfyModel
                                window.location.href = "/shopify";
                                return
                            }
                            setShowDrawer(true); setDrawerType('shopify')
                        }

                    }} />
                    <ShopOutlined className="icon shop" />
                    <h4>Sell Shopify Product <Tag color="purple">Beta</Tag></h4>

                    <p>
                        Instantly share your Shopify products inside Instagram posts, reels, or stories.
                        Make it easy for followers to view and buy without leaving the app — boosting engagement
                        and driving higher conversions.
                    </p>

                </div>

                {flow_editor != "true" && <div className="automate-options"
                    onClick={(event) => {
                        window.location.href = "/home?tab=3"
                    }} >
                    <Switch value={flow_editor == "true"} className="switch" />
                    <ApartmentOutlined className="icon flow-node" />
                    <h4>Collect Email / Lead Gen</h4>

                    <p>
                        You know you can collect email, phone number, ratings using our advanced flow editor.
                    </p>

                </div>}

                {/* <div className="automate-options" onClick={(event) => {

                    if (event.target.className !== "ant-switch-inner" && event.target.className !== "ant-switch-handle") {
                        setShowDrawer(true);
                        setDrawerType('reply');
                    }
                }} >
                    <Switch value={data.auto_reply.enable} className="switch" onClick={(value) => {

                        if (value == false) {
                            showConfirm('Auto Reply')
                        }
                        else {
                            setShowDrawer(true); setDrawerType('reply')
                        }

                    }} />
                    <BranchesOutlined className="icon flow" />
                    <h4>Build Custom Flow</h4>
                    {post_type == "stories" ?
                        <p>When your audience replies to your story for "Link" or any other specified word. Automatically send them resources via direct message(DM).</p>
                        :
                        <p>When your audience comments "Link" or any other specified word. Automatically send them resources via comment and direct message(DM).</p>
                    }
                </div> */}
            </div>




        </>)
    }

    function ListPostComments() {
        function unixToLocalDateTime(unixTimestamp) {
            const date = new Date(unixTimestamp * 1000); // convert seconds to milliseconds
            return date.toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
        }
        function convertToLocalDateTime(dateString) {

            try {

                const date = new Date(dateString);

                // return date.toLocaleTimeString();
                const utcTime = new Date(dateString);

                const localTime = new Date(utcTime + 'Z').toLocaleString([], { hour12: true, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });

                return localTime
            }
            catch {
                return "-"
            }

        }


        // Utility function to safely access deeply nested properties
        const safeAccess = (fn, fallback = "N/A") => {
            try {
                return fn();
            } catch {
                return fallback;
            }
        };

        // Utility function to get comment text safely
        const getCommentText = (record) => {
            if (record.story_reply) {
                return <Tag color="geekblue">DM Reply</Tag>
            }
            return safeAccess(
                () => record.event_dumb.entry[0].changes[0].value.text,
                record.event_dumb.text || "NA"
            );
        };

        // Columns definition with safe handling
        const hasCity = postCommentsList.some(record => !!record.city);
        const columns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => record.event_core.from.username ? <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">  {record.event_core.from.username}</a> : <p> {record.event_core.from.name}</p>

                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {

                title: 'Status',
                render: (_, record) =>
                (<>


                    {record.order_status === "completed" && (
                        <a
                            href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Tag color="green" icon={<DollarCircleOutlined />}>
                                Sale {record?.order_data?.order_data?.name}
                            </Tag>
                        </a>
                    )}

                    {record.sp_status && <> <Tag color="purple" icon={<ShopOutlined />}>{record?.sp_status}</Tag></>}

                    {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon={<WarningOutlined />}> Instagram limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for auto process.</Button>} </>}
                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={!["428337", "428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits." : "This comment reached hourly limit, before switching plan."}> <Tag color="red" icon={<WarningOutlined />}>Rate limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for higher rate limits.</Button>} </>}
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon={<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.sp_status && !record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon={<SendOutlined />}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon={<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {record.link_opened && <> <Tag color="purple" icon={<BsCursor />}>Link Opened</Tag></>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                </>),
                // record.responded ? (
                //     <Tag icon={<CheckCircleOutlined />} color="success">
                //         success
                //     </Tag>
                // ) : (
                //     <Tooltip title="Error" color={'red'} key={'red'}>
                //         <Tag icon={<CloseCircleOutlined />} color="error">
                //             error
                //         </Tag>
                //     </Tooltip>
                // ),
                key: 'responded',
            },
            ...(hasCity ? [

                {
                    title: <p>City</p>,
                    render: (_, record) =>
                    (<>
                        {record.city && <p>{record.city}</p>}

                    </>),

                    key: 'city'
                },
            ] : []),
            {
                title: 'Comment',
                render: (_, record) =>
                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].message.text,
                                record.event_dumb.from?.username
                            )}
                        </p>
                    ) : (
                        <p>{getCommentText(record)}</p>
                    ),
                key: 'comment',
            },
            {
                title: 'Responded Time',
                render: (_, record) => record.waiting ? `Sechduled at ${convertToLocalDateTime(record.responded_at)}` : convertToLocalDateTime(record.responded_at),
                key: 'rt',
            },
        ];

        // Mobile columns with safe handling
        const mobileColumns = [
            {
                title: 'Insta ID',
                render: (_, record) =>

                    post_type === "stories" ? (
                        <p>
                            {safeAccess(
                                () => record.event_dumb.entry[0].messaging[0].sender.id,
                                record.event_dumb?.from?.username
                            )}
                        </p>
                    ) : (
                        <p >
                            {safeAccess(
                                () => <a href={`https://instagram.com/${record.event_core.from.username}`} target="_blank">{record.event_core.from.username}</a>

                            )}
                        </p>
                    ),
                key: 'id',
                maxWidth: '100px',
            },
            {
                title: 'Status',
                render: (_, record) =>

                (<div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {record.order_status === "completed" && (
                        <a
                            href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Tag color="green" icon={<DollarCircleOutlined />}>
                                Sale {record?.order_data?.order_data?.name}
                            </Tag>
                        </a>
                    )}

                    {record.sp_status && <> <Tag color="purple" icon={<ShopOutlined />}>{record?.sp_status}</Tag></>}

                    {record.ig_rate_limit && <><Tooltip title="Instagram limit reached"> <Tag color="red" icon={<WarningOutlined />}> Instagram limit reached</Tag></Tooltip> {!["428337", "428338"].includes(localStorage.getItem("planid")) && <Button color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade your plan for auto process.</Button>} </>}
                    {(!record.ig_rate_limit && record.hourly_limit_reached) && <><Tooltip title={!["428337", "428338"].includes(localStorage.getItem("planid")) ? "Hourly limit reached. Upgrade your plan for higher rate limits." : "This comment reached hourly limit, before switching plan."}> <Tag color="red" icon={<WarningOutlined />}>Rate limit reached</Tag></Tooltip> {["428337", "428338"].includes(localStorage.getItem("planid")) && <Button style={{ marginTop: '20px' }} color="primary" variant="outlined" onClick={() => { setShowPlan(true) }}>Upgrade for higher rate limit</Button>} </>}
                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                    {record.waiting && <> <Tooltip title="Waiting in Queue"> <Tag color="geekblue" icon={<ClockCircleOutlined />}>Scheduled</Tag> </Tooltip> </>}
                    {(!record.sp_status && !record.hourly_limit_reached && !record.waiting) && record.dm_responded == "true" && <> <Tooltip title="DM Sent"> <Tag color="green" icon={<SendOutlined />}>Sent</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting) && record.dm_responded != "true" && <> <Tooltip title="DM Not Sent"> <Tag color="red" icon =  {<SendOutlined/>}>Failed</Tag> </Tooltip> </>} */}
                    {(!record.hourly_limit_reached && !record.waiting && record.cm_responded == "true" && record.story_reply != true) && <> <Tooltip title="Comment replied"> <Tag color="green" icon={<CommentOutlined />}>Replied</Tag> </Tooltip> </>}
                    {/* {(!record.hourly_limit_reached && !record.waiting && !record.waiting && record.cm_responded == "false" && record.story_reply == false) && <> <Tooltip title="Comment not replied"> <Tag color="red" icon = {<CommentOutlined />}>Failed</Tag> </Tooltip> </>} */}
                    {record.link_opened && <> <Tag color="purple" icon={<BsCursor />}>Link Opened</Tag></>}
                    {record.city && <> <Tag color="orange" icon={<GlobalOutlined />}>{record.city}</Tag></>}
                </div>),
                key: 'responded',
            },

        ];



        if (commentsLoading || postCommentsList.length < 1) {
            return <div style={{ width: '100%', height: '100hh', display: 'flex', alignContent: 'center', justifyContent: 'center' }}> <Spin indicator={<LoadingOutlined spin />} style={{ marginRight: '10px' }} />Please Wait...</div>
        }

        return (
            <div>

                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={columns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: false,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                {record?.order_data?.order_data?.id && <Button href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`} target="_blank">See Order {record?.order_data?.order_data?.name}</Button>}

                                <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >
                                    #id: {record.comment_id} <br />
                                    {record.paid && <> <Tag color="geekblue" icon={<MoneyCollectTwoTone />}>Paid</Tag></>}
                                    # DM Sent : {record.waiting ? "Scheduled" : record.dm_responded} <br />
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>

                                <StatusTimeline timeline={record?.sp_status_timeline} />
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="desktop"
                />

                <Table dataSource={postCommentsList}
                    tableLayout="auto"
                    rowKey={(record) => record.comment_id}
                    columns={mobileColumns}
                    pagination={false}
                    expandable={{
                        expandRowByClick: true,
                        // defaultExpandAllRows:true,
                        expandedRowRender: (record) => (
                            <div>
                                {record?.order_data?.order_data?.id && <Button href={`https://admin.shopify.com/store/${record?.order_data?.order_data?.line_items?.[0]?.vendor}/orders/${record?.order_data?.order_data?.id}`} target="_blank">See Order {record?.order_data?.order_data?.name}</Button>}

                                <StatusTimeline timeline={record?.sp_status_timeline} />

                                {post_type != "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px'
                                    }}
                                >

                                    Comment :{getCommentText(record)} <br /> <br />

                                    {record.waiting ? "Sechduled at" : "Responded at"} {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id} <br />
                                </p>
                                }
                                {post_type == "stories" && <p
                                    style={{
                                        margin: 0,
                                        color: 'grey',
                                        fontSize: '12px',
                                        overflowX: 'hidden'
                                    }}
                                >

                                    Comment : {record.event_dumb.entry != undefined ? record.event_dumb["entry"][0].messaging[0]["message"]["text"] : record.event_dumb?.text} <br />
                                    Replied at : {convertToLocalDateTime(record.responded_at)} <br />
                                    #id: {record.comment_id.slice(0, 40)} <br />
                                    # Link Opened Time : {convertToLocalDateTime(record.link_open_at) == "Invalid Date" ? "NA" : convertToLocalDateTime(record.link_open_at)}
                                </p>
                                }
                            </div>
                        ),
                        // rowExpandable: (record) => record.reason !== 'Not Expandable',
                    }}
                    className="mobile"
                />
                <Button href="#" onClick={() => setCommentPaginationPageChange(commentPaginationPageChange + 1)} type="primary"
                    style={{ padding: '10px', width: '100px', marginTop: '20px', marginBottom: '20px' }}
                    disabled={postCommentsList.length >= dashboardAPIData?.total_comments}>Load More</Button>
            </div>
        )
    }


    return (
        <div className="page-layout">
            {contextHolder}
            <Sider setShowPlan={setShowPlan} showPlan={showPlan} />



            <div className="page-content">
                {flow_editor == "true" && <Alert
                    style={{ marginBottom: '10px', marginTop: '10px' }}
                    message="Configured via Flow Editor, but editable!"
                    description="This post was set up through the Flow Editor. You can edit it manually, but any modifications will replace the existing Flow Editor settings for this post alone."
                    type="warning"

                />
                }


                {
                    params.id == "global" && <Alert
                        style={{ marginBottom: '10px', marginTop: '10px' }}
                        message="Global Automation"
                        description="This is a global automation, it will apply to all posts and stories. But post specific automation will override this."
                        type="info" />
                }
                <Breadcrumb
                    style={{ marginTop: '20px' }}
                    separator=">"
                    items={[
                        {
                            title: <Link to={platform_type == "insta" ? "/home" : "/fb"}>{post_type == "stories" ? "Stories" : post_type == "next-post" ? "Next post" : "Posts"}</Link>,

                        },
                        {
                            title: 'Automation',
                        },
                    ]}
                />

                {/* {post_type != "next-post" && dashboardAPIData?.total_comments != undefined && <Row style={{ marginTop: '20px' }} gutter={18}>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Total DM's" : "Total Comments"} value={dashboardAPIData?.total_comments || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Automated DM's" : "Automated Comments"} value={dashboardAPIData?.total_responded || 'NA'} formatter={formatter} />
                    </Col>
                    {dashboardAPIData?.shopify_sale > 0 && <Col span={6}>
                        <Statistic title={"Sales"} value={dashboardAPIData?.shopify_sale || 'NA'} formatter={formatter} />
                    </Col>}
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Waiting DM's" : "Waiting Comments"} value={dashboardAPIData?.total_waiting || 'NA'} formatter={formatter} />
                    </Col>
                    <Col span={6}>
                        <Statistic title={post_type == "stories" ? "Skipped DM's" : "Skipped Comments"} value={dashboardAPIData?.limit_reached_count || 'NA'} formatter={formatter} />
                    </Col>
                </Row>
                } */}
                <Tabs
                    defaultActiveKey="1"
                    items={[{
                        key: 1,
                        label: `Automation Configuration `,
                        children: <AutomationSetup />,
                        icon: '',
                    },
                    post_type != "next-post" && {
                        key: 2,
                        label: post_type == "stories" ? `All DM's` : `All Comments`,
                        children: <ListPostComments />,
                        icon: '',
                    }
                        // {
                        //     key: 3,
                        //     label: `Replied Comments`,
                        //     children: `List of replied Comments`,
                        //     icon: '',
                        // },{
                        //     key: 4,
                        //     label: `Hidden Comments`,
                        //     children: `List of Hidden Comments`,
                        //     icon: '',
                        // },{
                        //     key: 5,
                        //     label: `Deleted Comments`,
                        //     children: `List of Deleted Comments`,
                        //     icon: '',
                        // },
                    ]}
                />
                <Drawer
                    title={drawerTypeObj[DrawerType]?.title}
                    placement="right"
                    open={showDrawer}
                    style={{ backgroundColor: '#EBF1FE' }}
                    // width={'600px'}
                    width={"100%"}
                    onClose={() => { setShowDrawer(false); setData(initalState) }}
                    extra={
                        <Space>
                            {DrawerType == "reply" &&
                                <Space>
                                    <Button onClick={() => { setShowDrawer(false); setData(initalState) }}>Cancel</Button>
                                    <Button type="primary"
                                        onClick={() => HandlePublish()} loading={posting}>
                                        Publish
                                    </Button>
                                </Space>}
                            {DrawerType == "shopify" &&
                                <Button type="primary"
                                    href="https://yt.opnin.app/9c3c5"
                                    target="_blank"
                                    icon={<VideoCameraOutlined />}>
                                    Watch Video
                                </Button>
                            }
                        </Space>


                    }
                >

                    {drawerTypeObj[DrawerType]?.comp}

                </Drawer>
            </div>

            <Modal

                open={showAccountWaring}
                onCancel={() => setShowAccountWaring(false)}
                footer={[
                    <Button key="edit" onClick={() => { setShowAccountWaring(false) }}>
                        Edit Automation
                    </Button>,
                    <Button key="publish" type="primary" onClick={() => {
                        setShowAccountWaring(false);
                        setCallPostApi(true)

                    }}>
                        Send link directly
                    </Button>,
                ]}
                centered
            >
                <Alert
                    type="info"
                    showIcon
                    message="Recommended Setup for Better Engagement"
                    description={
                        <>
                            <h3>
                                Enable a <strong>welcome message</strong> or <strong>follow-for-link</strong> to improve results.
                            </h3>
                            <p> This helps build trust and boosts engagement before your links are shared.</p>
                            <Tooltip title="Users who enable welcome messages or require a follow before sending links tend to see better interaction rates and smoother message delivery.">

                                <p style={{ textDecoration: "underline" }}>What does this mean?</p>
                            </Tooltip>
                        </>
                    }
                />
            </Modal>


            <Modal
                title="Select FB Post"
                open={showFbLinkModal}
                onCancel={() => {
                    setShowFbLinkModal(false);
                    setLoadFBPosts(0);
                }}
                width={700}
                footer={[
                    <Button
                        key="cancel"
                        onClick={() => {
                            setShowFbLinkModal(false);
                            setLoadFBPosts(0);
                        }}
                    >
                        Cancel
                    </Button>,
                    <Button
                        key="select"
                        type="primary"
                        disabled={!selectedFBDetail}
                        onClick={() => {
                            setFBDetail(selectedFBDetail);
                            setShowFbLinkModal(false);
                            setLoadFBPosts(0);
                        }}
                    >
                        Select Post
                    </Button>,
                ]}
            >
                <div style={{ maxHeight: "420px", overflowY: "auto", padding: "8px 0" }}>
                    {fbPosts?.posts_lists?.data ? (
                        <Flex wrap gap={10} justify="flex-start" align="center">
                            {fbPosts.posts_lists.data.map((post, index) => {
                                const imgSrc =
                                    post.thumbnail_url || post.media_url || post.full_picture;
                                const isSelected = selectedFBDetail?.id === post.id;

                                return (
                                    <div
                                        key={post.id || index}
                                        onClick={() => setSelectedFBDetail(post)}
                                        style={{
                                            cursor: "pointer",
                                            border: isSelected
                                                ? "2px solid #1677ff"
                                                : "1px solid #e0e0e0",
                                            borderRadius: 10,
                                            overflow: "hidden",
                                            transition: "all 0.2s ease",
                                            boxShadow: isSelected
                                                ? "0 2px 8px rgba(22, 119, 255, 0.2)"
                                                : "0 1px 4px rgba(0,0,0,0.05)",
                                        }}
                                    >
                                        <img
                                            alt={post.caption}
                                            style={{
                                                width: 150,
                                                height: 150,
                                                objectFit: "cover",
                                                display: "block",
                                            }}
                                            className="thumbnail-img"
                                            src={imgSrc}
                                            crossOrigin="anonymous"
                                        />
                                    </div>
                                );
                            })}
                        </Flex>
                    ) : (
                        <div style={{ textAlign: "center", color: "#999", padding: "40px 0" }}>
                            No Facebook posts found
                        </div>
                    )}

                    {fbPosts?.posts_lists?.paging?.cursors?.after && (
                        <div style={{ textAlign: "center", marginTop: 20 }}>
                            <Button
                                type="default"
                                shape="round"
                                onClick={() =>
                                    setLoadFBPosts(fbPosts.posts_lists.paging.cursors.after)
                                }
                            >
                                Load More
                            </Button>
                        </div>
                    )}
                </div>
            </Modal>

        </div>
    )

}

export default Automations;
